import React from 'react'
import Layout from '../components/layout'
import SEO from '../components/seo'
import colours from '../lib/colours'
import styled from 'styled-components'
import { SidebarMaxWidth, MobileDeviceWidth } from '../lib/constants'
import MapControl from '../controls/map-control'
import StateHeader from '../components/state-header'
import { FrontMatter } from '../lib/models'
import SmartScroll from '../components/smart-scroll'
import IEventedComponent, {
  messageTypes
} from '../components/IEventedComponent'
import isMobile from '../lib/is-mobile'
import isWarningBannerVisible from '../lib/is-warning-banner-visible'
import { DeviceChangedEvent } from '../lib/messages'
import MobileMapControl from '../controls/mobile-map-control'
import PanelReturnLinkControl from '../controls/panel-return-link-control'
import { MaskChangedEvent } from '../lib/messages'


const StyledWrapper = styled.div`
  color: ${colours.darkBlue};
  display: flex;
  flex-direction: column;
  height: 100vh;
`

const StyledRow = styled.div`
  flex: 1;
  min-height: 100px;
`

const DesktopSidebarDiv = styled.div`
  position: relative;
  height: 100%;
  max-width: 500px;
  font-weight: lighter;
  color: ${colours.black};
  flex: 0 0 ${SidebarMaxWidth}px;
  @media (max-width: ${MobileDeviceWidth}px) {
    flex: 1;
    max-width: 100%;
    width: 100%;
  }
`

const PaddedDiv = styled.div`
  padding-left: 26px;
  padding-right: 26px;
  padding-top: 26px;
  @media (max-width: ${MobileDeviceWidth}px) {
    padding-left: 18px;
    padding-right: 18px;
  }
`

interface IProps {
  pageContext: any
}

interface IState {
  isMobile: boolean
  isWarningBannerVisible: boolean
  isScrollHintVisible: boolean
}

class DefaultPageLayout extends IEventedComponent<IProps, IState> {
  state: IState = {
    isMobile: isMobile(),
    isWarningBannerVisible: isWarningBannerVisible(),
    isScrollHintVisible: true
  }

  frontMatter?: FrontMatter = undefined

  onClickRegionMask = (maskIndex:number) => {
  const maskId = maskIndex
  this.publish<MaskChangedEvent>(messageTypes.onMaskChanged, {
        maskId
      })
  }


  constructor(props: IProps) {
    super(props)
    this.frontMatter = this.props.pageContext.frontmatter as FrontMatter
  }

  componentDidMount() {
    this.subscribe(messageTypes.onDeviceChanged, this.handleDeviceChanged)
    this.subscribe(
      messageTypes.onWarningBannerClosed,
      this.handleWarningBannerClosed
    )
    this.setState({ isWarningBannerVisible: isWarningBannerVisible() })
  }

  handleDeviceChanged = (message: DeviceChangedEvent) => {
    this.setState({ isMobile: message.isMobile })
  }

  handleWarningBannerClosed = () => {
    this.setState({ isWarningBannerVisible: false })
  }

  handleFirstScroll = () => {
    this.setState({ isScrollHintVisible: false })
  }

  render() {
    return (
      <StyledWrapper>
        <Layout isWarningBannerVisible={this.state.isWarningBannerVisible}>
          <SEO
            title={this.frontMatter?.title || 'Unknown Region'}
            description={this.frontMatter?.summary}
          />
        </Layout>

        <StyledRow className="row no-gutters">
          <DesktopSidebarDiv>
            <SmartScroll>
              <StateHeader frontMatter={this.frontMatter}>
              
                {this.state.isMobile && (
                  <MobileMapControl frontMatter={this.frontMatter || {}} />
                )}
              </StateHeader>
              <PaddedDiv className="sidebar-content">
                {this.props.children}
              </PaddedDiv>
              <PanelReturnLinkControl text="Explore the state" />
            </SmartScroll>
          </DesktopSidebarDiv>
          
          {!this.state.isMobile && (
            <div className="col">
              <MapControl
                region={this.frontMatter?.region || 'unknown'}
                regionTitle={this.frontMatter?.title || 'Unknown Region'}
              />
            </div>
          )}
        </StyledRow>
      </StyledWrapper>
    )
  }
}

export default DefaultPageLayout
